import { render, staticRenderFns } from "./FactoryInvoiceManagement.vue?vue&type=template&id=19b52f22&scoped=true"
import script from "./FactoryInvoiceManagement.vue?vue&type=script&lang=ts"
export * from "./FactoryInvoiceManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b52f22",
  null
  
)

export default component.exports